import isNil from "lodash/isNil"
import { jwtDecode } from 'jwt-decode'
import { getPendoScript } from './pendoScript'
import { getCookieValue } from "../helpers/cookieHelper"

export const initializePendo = (ujwt) => {

  if(!isNil(ujwt)) {
    try {
      const decode = jwtDecode(ujwt)
      const productInstanceId = getCookieValue('_sp_productInstanceId')
      const pendoScript = getPendoScript(productInstanceId, decode.act.originatorUserId, decode.sub)
      const script = document.createElement('script')
      script.async = true
      script.type = 'text/javascript'
      script.innerHTML = pendoScript
      document.body.appendChild(script)
      console.info('Pendo initialized')
    }
    catch (e) {
      console.warn('Error initializing pendo ', e)
    }
    
  }

}
